import AppVars from "./AppVars.js";
import axios from 'axios'
import {
  setCookies,
  isValidGoToURL,
  parseCookies,
} from "account-portal-library/lib/helperFunctions";
import { USER_ID_QUERY_PARAM } from "./constants/constants.js";

const appVars = AppVars.getInstance();

export class GotoUrl {
  constructor(url) {
    this.raw = url;
    this.encryptedUserId = new URL(url).searchParams.get(USER_ID_QUERY_PARAM);
    this.passedUserId = decrypt(this.encryptedUserId);
  }
}

export class GotoUrlCookie {
  static set(gotoUrl) {
    setCookies("goto", gotoUrl, "/", appVars.getDomain());
  }
  static get() {
    const parsedCookies = parseCookies(document.cookie);
    return Object.keys(parsedCookies).includes("goto")
      ? parsedCookies["goto"]
      : undefined;
  }
}

export function getGotoUrlFromCookies(brands = ["T"]) {
  const gotoUrl = GotoUrlCookie.get();
  if (gotoUrl && brands.some((brand) => isValidGoToURL(brand, gotoUrl))) {
    return gotoUrl;
  }
  return getDefaultGotoUrl();
}

async function decrypt(ciphertext) {
  const config={
    method: 'POST',
    url: appVars.getECPCApiGatewayURL(),
    headers: {
        'Content-Type': 'application/json'            
      },
      data: {
        'email' : ciphertext
    }  
}
try {
  const res = await axios(config);
  //const decryptedEmail = res.data.email;
  
  let useobj = JSON.parse(res.data);
  const decryptedEmail = useobj.email;
  console.log("Decrypted email value:", decryptedEmail);
  if (typeof decryptedEmail !== 'string') {
    throw new Error('Decrypted email was not a string')
  }
  return decryptedEmail;
} catch (error) {
  console.error(error);
  return null;
}
}
function getDefaultGotoUrl() {
  return (
    appVars.getBaseUrl() +
    "/" +
    appVars.getName() +
    "/oauth2/realms/root/realms" +
    appVars.getRealm() +
    "/authorize?client_id=" +
    appVars.getDefaultClientId() +
    "&response_type=code&scope=openid%20profile&redirect_uri=" +
    appVars.getDefaultRedirectURI()
  );
}